export const iconSize = 60;
